/**
 * The welcome is shown once per sign-in: the login screen marks it pending, the shell's greeting
 * reads and clears it. Session storage, not memory, so a reload on the first page does not lose
 * it midway and a new tab (a new session for this purpose) does not repeat it.
 */
const WELCOME_KEY = 'instoque.boas-vindas';

export function markWelcomePending(): void {
  try {
    sessionStorage.setItem(WELCOME_KEY, '1');
  } catch {
    // Storage blocked (private window): the greeting is a nicety, the sign-in goes on without it.
  }
}

export function isWelcomePending(): boolean {
  try {
    return sessionStorage.getItem(WELCOME_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearWelcome(): void {
  try {
    sessionStorage.removeItem(WELCOME_KEY);
  } catch {
    // Nothing to clear when storage is blocked.
  }
}

/** "Bom dia" / "Boa tarde" / "Boa noite" by the hour in São Paulo, where every customer is. */
export function greetingFor(date: Date = new Date()): string {
  const hourPart = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Sao_Paulo',
    hour: 'numeric',
    hourCycle: 'h23',
  })
    .formatToParts(date)
    .find((part) => part.type === 'hour');
  const hour = Number(hourPart?.value ?? '12');

  if (hour >= 5 && hour < 12) {
    return 'Bom dia';
  }
  if (hour >= 12 && hour < 18) {
    return 'Boa tarde';
  }
  return 'Boa noite';
}

export function firstName(fullName: string | undefined): string | undefined {
  const first = fullName?.trim().split(/\s+/u)[0];
  return first === undefined || first === '' ? undefined : first;
}
